<ng-container *ngIf="type === 'small'; then small else big"></ng-container>
<ng-template #big>
  <span style="font-size: .9rem;" *ngIf="booking?.timingStatus==='Future'"
        class="badge blue">{{'lang.globals.planned' | translate}}</span>
  <span style="font-size: .9rem;" *ngIf="booking?.timingStatus==='Present'"
        class="badge green">{{'lang.globals.running' | translate}}</span>
  <span style="font-size: .9rem;" *ngIf="booking?.timingStatus==='Past'"
        class="badge grey">{{'lang.globals.expired' | translate}}</span>
  <span style="font-size: .9rem;" *ngIf="booking?.timingStatus==='Unknown'"
        class="badge grey">{{'lang.globals.noTiming' | translate}}</span>
</ng-template>
<ng-template #small>
  <span [ngbTooltip]="'lang.globals.planned' | translate" container="body" placement="right"
        *ngIf="booking?.timingStatus==='Future'" class="dot glow blue blue-bg"></span>
  <span [ngbTooltip]="'lang.globals.running' | translate" container="body" placement="right"
        *ngIf="booking?.timingStatus==='Present'" class="dot glow green green-bg"></span>
  <span [ngbTooltip]="'lang.globals.expired' | translate" container="body" placement="right"
        *ngIf="booking?.timingStatus==='Past'" class="dot glow grey grey-bg"></span>
  <span [ngbTooltip]="'lang.globals.noTiming' | translate" container="body" placement="right"
        *ngIf="booking?.timingStatus==='Unknown'" class="dot glow grey grey-bg"></span>
</ng-template>
